// extracted by mini-css-extract-plugin
export default {"spinner":"XnAhaR","label":"g91Ozo"};